var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateIconPrompt = function SvgCreateIconPrompt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15m0 13.75A6.257 6.257 0 0 1 3.75 10 6.257 6.257 0 0 1 10 3.75 6.257 6.257 0 0 1 16.25 10 6.257 6.257 0 0 1 10 16.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M10 5a3.13 3.13 0 0 0-3.125 3.125.625.625 0 0 0 1.25 0c0-1.034.84-1.875 1.875-1.875 1.034 0 1.875.84 1.875 1.875C11.875 9.159 11.035 10 10 10a.625.625 0 0 0-.625.625v1.25a.625.625 0 1 0 1.25 0v-.688a3.13 3.13 0 0 0 2.5-3.062A3.13 3.13 0 0 0 10 5M9.063 14.063a.937.937 0 1 0 1.874 0 .937.937 0 0 0-1.874 0"
  })));
};
export default SvgCreateIconPrompt;